module.exports = __webpack_public_path__ + "static/media/hat-cowboy-side.7a8549c3.svg";